import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["onClick"]

import {PropType} from "vue";
import {useRouter} from "vue-router";
import {VABreadcrumbItem} from "./typings";


export default /*@__PURE__*/_defineComponent({
  __name: 'VABreadcrumb',
  props: {
  options: {
    type: Array as PropType<Array<VABreadcrumbItem>>
  }
},
  setup(__props) {

const router = useRouter()



const go = (item: VABreadcrumbItem) => {
    router.push({name: item.name, query: {...item.query || {}}})
}


return (_ctx: any,_cache: any) => {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!

  return (_openBlock(), _createBlock(_component_a_breadcrumb, { style: {"margin":"10px 0","font-size":"13px"} }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.label
        }, [
          (item.name)
            ? (_openBlock(), _createBlock(_component_a_breadcrumb_item, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (go(item)),
                    class: "va-breadcrumb-to",
                    style: _normalizeStyle(`color: ${item.color}`)
                  }, _toDisplayString(item.label), 13, _hoisted_1)
                ]),
                _: 2
              }, 1024))
            : (_openBlock(), _createBlock(_component_a_breadcrumb_item, {
                key: 1,
                style: _normalizeStyle(`color: ${item.color}`)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["style"]))
        ], 64))
      }), 128))
    ]),
    _: 1
  }))
}
}

})